module.exports = {
      id: "photo-on-poster-and-on-dibond-privately-usage",
      viewBox: "0 0 352.1 476.5",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#photo-on-poster-and-on-dibond-privately-usage",
      toString: function () {
        return this.url;
      }
    }